/**
 * simulator/pages/autoescuela/planProfesorSim.js — el simulador de autoescuela en modo «Plan Profesor».
 *
 * Lo usan la tarjeta «Profesor (Plan Profesor)» del selector del simulador (SimulatorSectorSelect) y la ficha del
 * lead con el sector «Profesor de autoescuela» (LeadEditModal → «Entrar al simulador»), para que las dos entradas
 * enseñen lo mismo. Mismo sector «autoescuela»; solo cambia lo que se ve:
 *   - las secciones que oculta el alta real del profesor (planProfesorAlta.js PROFESOR_MODULOS_OCULTOS);
 *   - un solo profesor (Carlos Navarro) con SUS alumnos y prácticas. Los datos de ejemplo se cambian EN SITIO (las
 *     páginas guardan la referencia a los arrays) y se restauran al entrar en la autoescuela normal.
 * Ficha: docs/features/autoescuela-plan-profesor.md
 */
import { setSeccionesOcultas, resetSeccionesOcultas, setPlanProfesorSim } from "./seccionesStore";
import { SECTOR_DATA_MAP } from "../../mockData";

// Espejo de aws_lambdas/_shared_autoescuela/planProfesorAlta.js PROFESOR_MODULOS_OCULTOS.
export const PROFESOR_MODULOS_OCULTOS = ["cursos", "fichajes", "flota", "cobros"];
const PROFESOR_ID = "inst-001";

let _original = null;
function aplicarDatosProfesor(on) {
  const d = SECTOR_DATA_MAP.autoescuela;
  if (!d) return;
  if (!_original) _original = { inst: [...(d.mockInstructors || [])], prac: [...(d.mockPracticas || [])], alu: [...(d.mockAlumnos || [])] };
  const poner = (arr, items) => { arr.splice(0, arr.length, ...items); };
  if (on) {
    poner(d.mockInstructors, _original.inst.filter((i) => i.instructor_id === PROFESOR_ID));
    poner(d.mockAlumnos, _original.alu.filter((a) => !a.instructor_id || a.instructor_id === PROFESOR_ID));
    const alumnos = new Set(d.mockAlumnos.map((a) => a.alumno_id));
    poner(d.mockPracticas, _original.prac.filter((p) => p.instructor_id ? p.instructor_id === PROFESOR_ID
      : (p.alumno_ids || [p.alumno_id]).every((id) => alumnos.has(id))));
  } else {
    poner(d.mockInstructors, _original.inst);
    poner(d.mockAlumnos, _original.alu);
    poner(d.mockPracticas, _original.prac);
  }
  setPlanProfesorSim(on);
}

/** true = modo Plan Profesor (un profesor, secciones ocultas); false = autoescuela entera (lo restaura). */
export function entrarModoProfesorSim(on) {
  aplicarDatosProfesor(!!on);
  if (on) setSeccionesOcultas(PROFESOR_MODULOS_OCULTOS);
  else resetSeccionesOcultas();
}
